import React from 'react';
import { SectionTitle } from '../../../components/SectionTitle';
import { FlexWrapper } from '../../../components/FlexWrapper';
import { Skill } from './skill/Skill';
import { Container } from '../../../components/Container';
import {S} from './Skills_Styles'
import { Fade } from "react-awesome-reveal";

const skillData = [
    {
        iconId:"code",
        title:"HTML5",
        description:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Doloremque totam architecto at fuga",
},
    {
        iconId:"css",
        title:"CSS",
        description:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Doloremque totam architecto at fuga",
},
    {
        iconId:"react",
        title:"REACT",
        description:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Doloremque totam architecto at fuga",
},
    {
        iconId:"figma",
        title:"FIGMA",
        description:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Doloremque totam architecto at fuga",
},
    {
        iconId:"typescript",
        title:"TYPESCRIPT",
        description:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Doloremque totam architecto at fuga",
},
    {
        iconId:"quote",
        title:"QUOTE",
        description:"Lorem ipsum dolor, sit amet consectetur adipisicing elit. Doloremque totam architecto at fuga",
}
]

export const Skills = () => {
    return (
        <S.Skills id={"skills"}>
            <Container>
                <SectionTitle>My Skills</SectionTitle>
                <FlexWrapper wrap={"wrap"} justify={"space-between"}>{/* в мар передаём переменную в нащем случае это скилл и передаем ее по первой букве. */}
                    <Fade cascade={true} damping={0.3}>
                    {skillData.map((s,index)=>{
                        return (
                            <Skill iconId={s.iconId} key={index}/* здесь вместо  нидекса должна быт id уникальный идентификатор */
                                   title={s.title}
                                   description={s.description} />
                        )
                    })}
                    </Fade>
                </FlexWrapper>
            </Container>
        </S.Skills>
    );
};
